export default {
    root: {
        "&:focus": {
          background: "$labelcolor"
        }
    }
};
